<template>
<div class="home-component">

        <div id="headerelement">
            <fixed-header :fixed.sync="isFixed" v-if ="showfixedheader">
                <nav class="navbar" :class="{ 'is-light-home': isFixed, 'is-primary-home': !isFixed }">
                    <container>
                    <header v-if ="normaldevice">
                        <div class="inner" style="padding-top:20px;">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="logo-opacity">
                                    <img class="v-middle" src="../assets/images/logo_white.svg">
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <ul class="top-menu">
                                        <li><a href="#" v-scroll-to="'#howitwork'">HOW IT WORKS</a></li>
                                        <li><a href="#" v-scroll-to="'#features'">FEATURES</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                    </ul>
                                    <button class="btn-head banner-head-get-btn raise banner-head-red-btn" type="button" v-scroll-to="'#plans'">SUBSCRIBE</button>
                                </grid-item>


                            </grid>
                        </div>
                    </header>
                    <header v-if ="smalldevice">
                        <div class="inner-sm">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="logo-opacity">
                                    <img class="v-middle" src="../assets/images/logo_white.svg">
                                    <!-- <span class="logo-text">vLite</span> -->
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <button type="button" class="btn-hamb" @click="toggleSidebar">
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                    </button>
                                    <button class="btn-head banner-head-get-btn raise banner-head-red-btn" type="button" v-scroll-to="'#plans'">SUBSCRIBE</button>
                                </grid-item>


                            </grid>

                            <!-- <div class="sidebar" v-show="sidebarVisible">
                                <div class="menus">
                                    <ul>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                        <li><a href="#" v-scroll-to="'#howitwork'" @click="toggleSidebar">HOW IT WORKS</a></li>
                                        <li><a href="#" v-scroll-to="'#features'" @click="toggleSidebar">FEATURES</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'" @click="toggleSidebar">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'" @click="toggleSidebar">BLOG</a></li>

                                    </ul>
                                </div>
                                <button type="button" class="btn-close-sidebar" @click="toggleSidebar">
                                    <icon scale="2.5" style="color:#bcbcbc;" name="times"></icon>
                                </button>
                            </div> -->
                        </div>
                    </header>
                </container>
                </nav>
            </fixed-header>

            <div class="banner landing-banner">
                <container>

                    <header v-if ="normaldevice">
                        <div class="inner">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="logo-opacity">
                                    <img class="v-middle" src="../assets/images/logo_white.svg">
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <ul class="top-menu">
                                        <li><a href="#" v-scroll-to="'#howitwork'">HOW IT WORKS</a></li>
                                        <li><a href="#" v-scroll-to="'#features'">FEATURES</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                    </ul>
                                </grid-item>


                            </grid>
                        </div>
                    </header>

                    <header v-if ="smalldevice">
                        <div class="inner-sm">
                            <grid horizontal="left">
                                <grid-item size="2/12" class="logo-opacity">
                                    <img class="v-middle" src="../assets/images/logo_white.svg">
                                    <!-- <span class="logo-text">vLite</span> -->
                                </grid-item>

                                <grid-item size="10/12" class="nav-items">
                                    <button type="button" class="btn-hamb" @click="toggleSidebar">
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                        <span class="strike"></span>
                                    </button>
                                </grid-item>


                            </grid>

                            <div class="sidebar" v-show="sidebarVisible">
                                <div class="menus">
                                    <ul>
                                        <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                        <li><a href="#" v-scroll-to="'#howitwork'" @click="toggleSidebar">HOW IT WORKS</a></li>
                                        <li><a href="#" v-scroll-to="'#features'" @click="toggleSidebar">FEATURES</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'" @click="toggleSidebar">PLANS</a></li>
                                        <li><a href="#" v-scroll-to="'#plans'" @click="toggleSidebar">BLOG</a></li>

                                    </ul>
                                </div>
                                <button type="button" class="btn-close-sidebar" @click="toggleSidebar">
                                    <icon scale="2.5" style="color:#bcbcbc;" name="times"></icon>
                                </button>
                            </div>
                        </div>
                    </header>


                    <div class="banner-content">
                        <h1 class="white-text">DIY Video SAAS Platform</h1>
                        <!-- <h2 class="cd-headline rotate-1">
                        <span class="cd-words-wrapper white-text">
                        <b id="neflix" class="is-visible">Video OTT Platform like Netflix&trade; and Hotstar&trade;</b>
                        <b id="udemy" class="is-hidden">E-Learning Platform like Khan Academy&trade; and Udemy&trade;</b>
                    </span>
                </h2> -->
                <!-- <h2 class="white-text">For MOOC & Entertainment Businesses</h2> -->
                <h2 class="white-text">
                    <div class="">
                        Build your own
                        <div class="rotating-words">
                            <span><strong>E-Learning</strong></span>
                            <span><strong>Video OTT</strong></span></div>
                        </div>

                        <div class="">
                            Platform like
                            <div class="rotating-words1">
                                <span><strong>Khan Academy&trade;</strong> and <strong>Udemy&trade;</strong> in 24 hours</span>
                                <span><strong>Netflix&trade;</strong> and <strong>Hotstar&trade;</strong> in 24 hours</span></div>
                            </div>

                        </h2>
                        <grid horizontal="left">
                            <grid-item size="7/12" class="zindex101">
                                <!-- <h3 class="white-text">Launch your video solution  at the click of a button.</h3> -->
                                <button class="btn banner-get-btn raise" type="button" v-scroll-to="'#plans'">SUBSCRIBE</button>
                                <button type="button" class="btn banner-get-btn-landing uppercase raise" @click="navigateToDemoPage()">CHECK DEMO</button>
                            </grid-item>
                            <grid-item  size="5/12" class="v-middle zindex101 relative">
                                <div class="trophy-image">
                                </div>
                                <!-- <img v-show ="(theme == 'A')" class="v-middle width-65" src="../assets/images/banner-gfx.svg">
                                <img v-show ="(theme == 'B')" class="v-middle width-65" src="../assets/images/banner-gfx-blue.svg"> -->
                            </grid-item>
                        </grid>

                    </div>
                </container>
            </div>

            <div class="banner" v-bind:class="landbanslide">
            </div>
        </div>

    <!-- <div class="landing-banner-slide"></div> -->

    <!-- How It Works -->

    <div id="remaingele">
        <div id="vl-what-is-it" class="vl-what-is-it-div">
            <container class="vl-how-works" >

                <grid horizontal="left">
                    <grid-item size="2/12">
                    </grid-item>
                    <grid-item size="8/12" class=" left-align-text">
                        <h1>What is it?</h1>
                    </grid-item>
                    <grid-item size="2/12">
                    </grid-item>
                </grid>
                <div class="clearfix"></div>
                <grid horizontal="left">
                    <grid-item size="2/12">
                    </grid-item>
                    <grid-item size="8/12" class=" left-align-text">
                        <p><strong>vLite&trade;</strong> is the leading DIY Video SAAS platform for entertainment and education. Now launch your E-Learning or Entertainment OTT solution in 24 hours with branded native apps on <strong>iOS, Android</strong> and <strong>Web.</strong></p>
                    </grid-item>
                    <grid-item size="2/12">
                    </grid-item>
                </grid>

                <grid horizontal="left">
                    <grid-item size="2/12">
                    </grid-item>
                    <grid-item size="8/12" class=" left-align-text">
                        <p>MSOs, LCOs, Content Owners and <strong>Youtube&trade;</strong> stars - Launch your own video OTT solution like <strong>Netflix&trade;, Hulu&trade; or Hotstar&trade;</strong> within few hours. Support both Live and VOD content as needed.</p>
                    </grid-item>
                    <grid-item size="2/12">
                    </grid-item>
                </grid>
            </container>

            <container>
                <grid horizontal="center" >
                    <grid-item size="2/12">
                    </grid-item>
                    <grid-item size="3.3/12" class="center">
                        <img class="v-middle" src="../assets/images/backendwhite.svg">
                        <p class="vl-icon-disc">Easy Management</p>
                    </grid-item>
                    <grid-item size="3.3/12" class="center">
                        <img class="v-middle" src="../assets/images/analyticsboard.svg">
                        <p class="vl-icon-disc">Realtime Data</p>
                    </grid-item>
                    <grid-item size="3.3/12" class="center">
                        <img class="v-middle" src="../assets/images/clientapps.svg">
                        <p class="vl-icon-disc">Native Apps</p>
                    </grid-item>
                    <grid-item size="2/12">
                    </grid-item>
                    <!-- <grid-item size="1/12">
                </grid-item> -->
            </grid>
        </container>

        <container class="vl-how-works" >
            <div class="clearfix"></div>
            <grid horizontal="left">
                <grid-item size="2/12">
                </grid-item>
                <grid-item size="8/12" class=" left-align-text">
                    <p>Universities, colleges, schools, coaching institutes and corporate trainers - Launch your own E-Learning platform like <strong>Khan Academy&trade;, Udemy&trade; or Coursera&trade;</strong> within few hours.</p>
                </grid-item>
                <grid-item size="2/12">
                </grid-item>
            </grid>

            <grid horizontal="left">
                <grid-item size="2/12">
                </grid-item>
                <grid-item size="8/12" class=" left-align-text">
                    <p>Built on reliable,secure cloud infrastructure, <strong>vLite&trade;</strong> provides easy delivery, management and monetization options for your live/entertainment/education content.</p>
                </grid-item>
                <grid-item size="2/12">
                </grid-item>
            </grid>
        </container>
    </div>

    <div class="vl-wrks">
        <div v-bind:class="workrect">
            <container>
                <grid horizontal="center" >
                    <grid-item size="2/12">
                    </grid-item>
                    <grid-item size="3/12" class="work-rectangle-pos white-text center">
                        <p v-bind:class="workrectcount" id="ban-count-start">
                            <countTo ref='example1' :startVal='60000' :endVal='80000' :duration='3000'></countTo>
                            <span v-bind:class="workrecttext">Viewers</span>
                        </p>
                    </grid-item>
                    <grid-item size="3/12" class="work-rectangle-pos white-text center">
                        <p v-bind:class="workrectcount">
                            <countTo ref='example2' :startVal='50' :endVal='500' :duration='3000'></countTo>
                            <span v-bind:class="workrecttext">Hours of Content </span>
                        </p>
                    </grid-item>
                    <grid-item size="3/12" class="work-rectangle-pos white-text center">
                        <p v-bind:class="workrectcount">
                            <countTo ref='example3' :startVal='30000' :endVal='50000' :duration='3000'></countTo>
                            <span v-bind:class="workrecttext">Minutes Watched</span>
                        </p>
                    </grid-item>
                    <grid-item size="2/12" v-if ="bannerspace">
                    </grid-item>
                </grid>
            </container>
        </div>
        <!-- <div class="wrk-rect-slide">
    </div> -->
    </div>


    <div class="wrk-rect-gap">

    </div>


    <!-- Key Features -->
    <div class="vl-key-feature" id="features" v-if ="normaldevice">
        <div class="vl-title">
            <h1 class="white-text vl-title-key-feat">Key Features</h1>
            <h2 class="white-text center vl-sub-key-title">Leading video features in a flexible, cost effective package</h2>
        </div>
        <div class="vl-key-feature-contain">
            <container>
                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" class="min-height-260">
                    <grid-item size="3/12" class="min-height-265 center">
                        <img src="../assets/images/icons/modes-icon.svg" class="vl-key-feature-head img-responsive" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text">MOOC and Entertainment</p>
                        <p class="vl-key-feature-sub-cont">Select your mode between E-Learning and Entertainment based on use case.</p>
                    </grid-item>
                    <grid-item size="3/12" class="min-height-265 center">
                        <img src="../assets/images/icons/instant-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text"> iOS, Android, Web Apps</p>
                        <p class="vl-key-feature-sub-cont">Select from available templates and themes. Branded customized native apps on iOS,Android and Web.</p>
                    </grid-item>
                    <grid-item size="3/12" class="min-height-265 center">
                        <img src="../assets/images/icons/livevideo.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text"> Live and VOD</p>
                        <p class="vl-key-feature-sub-cont">Video on Demand (VOD) support by default. Live streaming supported for Entertainment mode.</p>
                    </grid-item>
                    <grid-item size="3/12" class="min-height-265 center">
                        <img src="../assets/images/icons/drm.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text">D R M*</p>
                        <p class="vl-key-feature-sub-cont">Secure your content using Digital Rights Management (DRM) module. Optional feature for enterprise grade content protection.</p>
                    </grid-item>
                </grid>

                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" class="min-height-260">
                    <grid-item size="3/12" class="center">
                        <img src="../assets/images/icons/monetization.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text"> Monetization Options*</p>
                        <p class="vl-key-feature-sub-cont">Monetize your content/course through video ads or transactional payment options.</p>
                    </grid-item>
                    <grid-item size="3/12" class="center">
                        <img src="../assets/images/icons/notifications-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text">User Notifications</p>
                        <p class="vl-key-feature-sub-cont">Engage with your users through targeted PUSH and Mail Notifications. Managed from console.</p>
                    </grid-item>
                    <grid-item size="3/12" class="center">
                        <img src="../assets/images/icons/analytics-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text">Real Time Analytics</p>
                        <p class="vl-key-feature-sub-cont">Track users and usage through platform and Google Analytics in real time.</p>
                    </grid-item>
                    <grid-item size="3/12" class="center">
                        <img src="../assets/images/icons/social-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text">Social Integration</p>
                        <p class="vl-key-feature-sub-cont">Share content on FB, Google and Twitter. Sign Up with FB and Google. Out of the box.</p>
                    </grid-item>
                </grid>

                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" class="min-height-260">
                    <grid-item size="3/12" class="center">
                    </grid-item>
                    <grid-item size="3/12" class="center">
                        <img src="../assets/images/icons/streaming-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text">Adaptive Streaming</p>
                        <p class="vl-key-feature-sub-cont">Adaptive bitrate streaming at multiple resolutions using DASH and HLS protocols. Pure HTML5 secure player for Web.</p>
                    </grid-item>
                    <grid-item size="3/12" class="center">
                        <img src="../assets/images/icons/admin-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont white-text">Intuitive Console</p>
                        <p class="vl-key-feature-sub-cont">Course/Content and User Management and Reporting through an easy intuitive vendor console.</p>
                    </grid-item>
                    <grid-item size="3/12" class="center">

                    </grid-item>
                </grid>
                <div class="white-text center vl-key-feat-bot-info">*Coming soon</div>
            </container>
        </div>
    </div>

    <!-- Key Features -->
    <div class="vl-key-feature" id="features" v-if ="smalldevice">
        <div class="vl-title">
            <h1 class="white-text vl-title-key-feat">Key Features</h1>
            <h2 class="white-text center vl-sub-key-title">Leading video features in a flexible, cost effective package</h2>
        </div>
        <div class="vl-key-feature-contain">
            <container>
                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" class="min-height-260">
                    <grid-item size="4/12" class="min-height-265 center">
                        <img src="../assets/images/icons/modes-icon.svg" class="vl-key-feature-head img-responsive" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text">MOOC and Entertainment</p>
                        <p class="vl-key-feature-sub-cont-sm">Select your mode between E-Learning and Entertainment based on use case.</p>
                    </grid-item>
                    <grid-item size="4/12" class="min-height-265 center">
                        <img src="../assets/images/icons/instant-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text"> iOS, Android, Web Apps</p>
                        <p class="vl-key-feature-sub-cont-sm">Select from available templates and themes. Branded customized native apps on iOS,Android and Web.</p>
                    </grid-item>
                    <grid-item size="4/12" class="min-height-265 center">
                        <img src="../assets/images/icons/livevideo.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text"> Live and VOD</p>
                        <p class="vl-key-feature-sub-cont-sm">Video on Demand (VOD) support by default. Live streaming supported for Entertainment mode.</p>
                    </grid-item>
                </grid>

                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" class="min-height-260">
                    <grid-item size="4/12" class="min-height-265 center">
                        <img src="../assets/images/icons/drm.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text">D R M*</p>
                        <p class="vl-key-feature-sub-cont-sm">Secure your content using Digital Rights Management (DRM) module. Optional feature for enterprise grade content protection.</p>
                    </grid-item>

                    <grid-item size="4/12" class="center">
                        <img src="../assets/images/icons/monetization.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text"> Monetization Options*</p>
                        <p class="vl-key-feature-sub-cont-sm">Monetize your content/course through video ads or transactional payment options.</p>
                    </grid-item>
                    <grid-item size="4/12" class="center">
                        <img src="../assets/images/icons/notifications-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text">User Notifications</p>
                        <p class="vl-key-feature-sub-cont-sm">Engage with your users through targeted PUSH and Mail Notifications. Managed from console.</p>
                    </grid-item>
                </grid>

                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" class="min-height-260">
                    <grid-item size="4/12" class="center">
                        <img src="../assets/images/icons/analytics-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text">Real Time Analytics</p>
                        <p class="vl-key-feature-sub-cont-sm">Track users and usage through platform and Google Analytics in real time.</p>
                    </grid-item>
                    <grid-item size="4/12" class="center">
                        <img src="../assets/images/icons/social-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text">Social Integration</p>
                        <p class="vl-key-feature-sub-cont-sm">Share content on FB, Google and Twitter. Sign Up with FB and Google. Out of the box.</p>
                    </grid-item>

                    <grid-item size="4/12" class="center">
                        <img src="../assets/images/icons/streaming-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text">Adaptive Streaming</p>
                        <p class="vl-key-feature-sub-cont-sm">Adaptive bitrate streaming at multiple resolutions using DASH and HLS protocols. Pure HTML5 secure player for Web.</p>
                    </grid-item>

                </grid>

                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" class="min-height-260">

                    <grid-item size="4/12" class="center" style="width:33%;">
                        <label class="img-responsive vl-key-feature-head"></label>
                        <p class="vl-key-feature-cont-sm white-text"></p>
                        <p class="vl-key-feature-sub-cont-sm"></p>
                    </grid-item>
                    <grid-item size="4/12" class="center" style="width:33%;">
                        <img src="../assets/images/icons/admin-icon.svg" class="img-responsive vl-key-feature-head" alt="feat-logo">
                        <p class="vl-key-feature-cont-sm white-text">Intuitive Console</p>
                        <p class="vl-key-feature-sub-cont-sm">Course/Content and User Management and Reporting through an easy intuitive vendor console.</p>
                    </grid-item>
                    <grid-item size="4/12" class="center" style="width:33%;">
                        <label class="img-responsive vl-key-feature-head"></label>
                        <p class="vl-key-feature-cont-sm white-text"></p>
                        <p class="vl-key-feature-sub-cont-sm"></p>
                    </grid-item>
                </grid>
                <div class="white-text center vl-key-feat-bot-info">*Coming soon</div>
            </container>
        </div>
    </div>

    <!-- How It Works -->
    <div id="howitwork" class="vl-how-works-div">
        <container class=" vl-how-works" id="howitwork">
            <h1 class="vl-how-works-title">How It Works</h1>
            <div class="clearfix"></div>
            <grid horizontal="left">
                <grid-item size="8/12" class="left-text right-align-text">
                    <h2 class="yellow">Subscribe with your info</h2>
                    <p>Select your <strong><a href="#"  style="color: #878787; font-weight:500" v-scroll-to="'#plans'">plan</a></strong>, specify platform requirement as MOOC or Entertainment, upload few details like logo, app name, description, contact, social links, app template and theme and subscribe.</p>
                </grid-item>
                <grid-item size="4/12" class="triangle-blue triangle-left"><span class="triangle-number">1</span>
                </grid-item>
            </grid>
        </container>

        <container class="vl-how-works">
            <div class="clearfix"></div>
            <grid horizontal="right">
                <grid-item size="2/12">
                </grid-item>
                <grid-item size="2/12" class="triangle-purple triangle-right" style="padding-top: 76px;"><span class="triangle-number">2</span>
                </grid-item>

                <grid-item size="8/12" class="left-text left-align-text">
                    <h2 class="yellow right-text">Get customized iOS, Android
                        and Web apps in 24 hours</h2>
                        <p>Your account gets activated in few hours post verification. You shall get branded iOS, Android and Web (if applicable) apps within 24 business hours. Our support team shall help you get started as needed. </p>
                    </grid-item>
                </grid>
            </container>

            <container class="vl-how-works left-text">
                <div class="clearfix"></div>
                <grid horizontal="left">
                    <grid-item size="8/12" class="left-text right-align-text">
                        <h2 class="yellow">Upload content, test
                            and go live!
                        </h2>
                        <p>Upload video content and metadata including poster, title, description and      tags using our easy,intuitive vendor console. All your content is secure and reliable on our AWS managed cloud. Verify the apps for content and data. Go live once you are ready!
                        </p>
                    </grid-item>
                    <grid-item size="4/12" class="triangle-yellow triangle-left"><span class="triangle-number">3</span>
                    </grid-item>
                </grid>
            </container>

            <!-- <container class="vl-how-works">
            <div class="clearfix"></div>
            <grid horizontal="right">
            <grid-item size="2/12">
        </grid-item>
        <grid-item size="2/12" class="triangle-blue-left triangle-right" style="padding-top: 76px;"><span class="triangle-number">4</span>
    </grid-item>

    <grid-item size="8/12" class="left-text left-align-text">
    <h2 class="blue right-text">Get customized iOS, Android
    and Web apps in 24 hours</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas fermentum id quam et sollicitudin. Nunc eu nisi dignissim, laoreet mauris a, maximus mi. Vivamus porttitor bibendum orci, ac interdum.</p>
    </grid-item>
    </grid>
    </container> -->

    </div>

    <!-- Plans -->
    <div class="vl-plans" id="plans">
        <h1 class="plan-text vl-title vl-title-key-plan">Plans</h1>
        <div class="center min-height-9">
            <span class="plan-switch-title">Select mode based on your use case</span>
            <div class="center m-top-20 m-bottom-20">
                <span>
                    <label class="control control--radio plan-chk-label" @click="changelistdata('MOOC')">MOOC
                        <input type="radio" name="type" id="mooc-plan-chk" value="MOOC" checked="checked"/>
                        <div class="control__indicator"></div>
                    </label>
                </span>
                <span style="margin-left:20px;">
                    <label class="control control--radio plan-chk-label" @click="changelistdata('LITE')">Entertainment
                        <input type="radio" name="type" id="lite-plan-chk" value="LITE"/>
                        <div class="control__indicator"></div>
                    </label>
                </span>
            </div>
        </div>
        <div class="vl-feat-box-contain">
            <container>
                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}" style="flex-flow: wrap;">
                    <grid-item size="4/12" v-for="(plandata, index) in planData" :key="plandata.planid">
                        <div :id="'vl-plan-box' + (index+1)" :class="[ plan , 'vl-plbox-'+((index%3)+1), (index===1) ? 'box-active':'']" @mouseenter="appendActiveClass(index+1)"  @click="appendActiveClass(index+1)">
                            <div class="vl-plan-head">
                                <h1>{{plandata.planname}}</h1>
                                <span>${{plandata.yearlyprice/100 - plandata.yearlydiscountedprice/100}} off</span>
                            </div>
                            <div class="vl-plan-box-cont">
                                <div class="m-top-25">
                                    <span class="curr-strike inline-blk">${{plandata.yearlyprice/100}}</span>
                                    <h3 class="vl-plbox-amnt inline-blk">${{plandata.yearlydiscountedprice/100}}</h3>
                                </div>
                                <p class="text-light center p-left-0 m-top-0">Annually</p>
                                <p class="pl-hgl-amt center p-left-0">Monthly <span>${{plandata.monthlydiscountedprice/100}}</span> </p>
                                <div :class="planhighlightbox">
                                    <p class="m-0 vl-plan-box-cont-hightlight">
                                        <span class="vl-plbox-instxt">{{(plandata.monthlywatchseconds/60).toLocaleString()}}</span> watching minutes/month</p>
                                        <p class="m-0 p-top-14 vl-plan-box-cont-hightlight"><span class="vl-plbox-instxt">{{(plandata.totalduration/3600).toLocaleString()}}</span> hours of content</p>
                                        <p v-show ="(plandata.maxchannelsactive > 0) && (mode=='LITE')" class="m-0 p-top-14 vl-plan-box-cont-hightlight"><span class="vl-plbox-instxt">{{(plandata.maxchannelsactive).toLocaleString()}}</span> Live Channels**</p>
                                    </div>
                                    <div class="" v-for="(listdata, index1) in listdataarr" :key="index1">
                                        <p class="m-0 p-top-10 vl-plan-box-cont-unhightlight vl-rltv">
                                            <span class="tick-list" :class="[ (listdataarrvals[index1][index] >= 1) ? 'tick-list':'cross-list']"><label  v-show ="(listdata=='Live Channels***') && (listdataarrvals[index1][index] >= 1)">{{listdataarrvals[index1][index]}} - </label>{{listdata}}</span></p>
                                        </div>

                                        <!-- <p class="m-0 p-top-14 vl-plan-box-cont-unhightlight tick-list">ios and Andriod Apps</p>
                                        <p class="m-0 p-top-14 vl-plan-box-cont-unhightlight tick-list">Web App with SSL</p>
                                        <p class="m-0 p-top-14  vl-plan-box-cont-unhightlight tick-list">Secure Sign Up and Authentication</p>
                                        <p class="m-0 p-top-14  vl-plan-box-cont-unhightlight tick-list">Course Credit and Questionnaire</p>
                                        <p class="m-0 p-top-14  vl-plan-box-cont-unhightlight tick-list">Course Level Management</p>
                                        <p class="m-0 p-top-14 vl-plan-box-cont-unhightlight cross-list">Institute Management</p>
                                        <p class="m-0 p-top-14  vl-plan-box-cont-unhightlight tick-list">Course Payments</p>
                                        <p class="m-0 p-top-14 vl-plan-box-cont-unhightlight cross-list">Google Analytics and Dashboard</p>
                                        <p class="m-0 p-top-14  vl-plan-box-cont-unhightlight tick-list">Course and Progress Reporting</p>
                                        <p class="m-0 p-top-14 vl-plan-box-cont-unhightlight cross-list">Business Hour Email Support</p>
                                        <p class="m-0 p-top-14 vl-plan-box-cont-unhightlight cross-list">Business Hour Email Support</p>
                                        <p class="m-0 p-top-14 vl-plan-box-cont-unhightlight cross-list">Business Hour Email Support</p> -->
                                        <!-- <p class="m-0 p-top-14 cross-list">24*7 Reliable SAAS</p>
                                        <p class="m-0 p-top-14 cross-list">Free Business Consulting</p> -->
                                    </div>
                                    <div class="vl-planbox-btns">
                                        <button type="button" class="btn vl-btn vl-plan-btn" @click="navigateToDashboard(index)">Subscribe</button>
                                    </div>
                                </div>
                            </grid-item>
                        </grid>
                        <grid horizontal="middle center" style="justify-content: center;align-items: center;">
                            <grid-item size="1/12">
                            </grid-item>
                            <grid-item size="10/12" class="center">
                                <span class="plan-info-data center">* Coming soon 	&nbsp;&nbsp;&nbsp;&nbsp;	<span v-if ="entviewdiv">**Live channel Feeds to be provided by customer or partner. Contact sales@mobiotics.com for more details.</span></span>
                            </grid-item>
                            <grid-item size="1/12">
                            </grid-item>
                        </grid>
                    </container>
                </div>
            </div>

            <div class="vl-vlive">
                <container style="padding: 3em 2em 8em 2em;">
                    <grid horizontal="middle center" style="justify-content: center;align-items: center;">
                        <!-- <grid-item size="1/12">
                    </grid-item> -->
                    <grid-item class="center">
                        <div class="vlive-div">
                            <p class="vlive vlive-bold m-0">You are an enterprise with thousands of hours of content, hundreds of live channels and need to cater to millions of subscribers?</p>
                        </div>
                        <div class="vlive-div">
                            <p class="vlive m-0"> Need custom UI/UX Apps on multiple device platforms? Need custom analytics and reports?</p>
                        </div>
                        <div class="vlive-div">
                            <p class="vlive m-0"> You can checkout our   <img src="../assets/images/vlive.png" class="v-middle" style="width: 24px;"/> <strong>vLive Enterprise Platform</strong></p>
                        </div>
                    </grid-item>
                    <!-- <grid-item size="1/12">
                </grid-item> -->
            </grid>
            <div class="v-middle center">
                <button type="button" class="btn banner-get-btn raise v1-plans-checknow">CHECK NOW</button>
            </div>
        </container>
    </div>

    <!-- Feature -->
    <!-- <div class="vl-feature-main-slide">
        <span class="bk-img-new"></span>
        <img v-show ="(theme == 'A')" src="../assets/images/gfx-f-bot.svg" alt="" style="width: 12%;">
        <img v-show ="(theme == 'B')" src="../assets/images/gfx-f-bot-blue.svg" alt="" style="width: 12%;">
    </div> -->
    <div class="vl-feature-cust relative">
        <h1 class="white-text vl-title vl-title-cust">Featured Customer</h1>
        <div class="vl-feat-box-contain">
            <container>
                <grid horizontal="middle" :rwd="{compact: 'stack-reverse'}">
                    <grid-item size="6/12">
                        <div class="vl-feat-box">
                            <div class="vl-feat-head">
                                <a href="https://lattukids.com" target="_blank"><img src="../assets/images/lattu-logo.png" class="img-responsive" alt="feat-logo"></a>
                            </div>
                            <div class="vl-feat-box-cont">
                                <p> The fast growing kids entertainment and learning platform chose vLite&trade; for its flexibility and ease of use. With iOS, Anrdoid and Web Apps Lattukids is able to reach out to kids across the world.</p>
                            </div>
                        </div>
                    </grid-item>
                    <grid-item size="6/12">
                        <div class="vl-feat-box">
                            <div class="vl-feat-head">
                                <a href="http://knowdiabetes.tv" target="_blank"><img src="../assets/images/knowdiabetes.png" class="img-responsive" alt="feat-logo"></a>
                            </div>
                            <div class="vl-feat-box-cont">
                                <p>kNOwDiabetes is the first e-Health channel in Malayalam. Aimed at creating awareness about diabetes among patients, high risk indivdiuals and care takers - this initiative by Medical Trust Hospital, Kulanada, Kerala chose vLIte&trade; platform and could go live fast.</p>
                            </div>
                        </div>
                    </grid-item>
                </grid>
            </container>
        </div>
    </div>

    <!--Footer-->
    <footer class="page-footer">
        <div class="footer-color">
            <container>
                <grid>
                    <grid-item size="4/12">
                        <div class="vl-foot-left">
                            <div class=" logo-opacity">
                                <!-- <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span> -->
                                <img class="v-middle" src="../assets/images/logo_white.svg" style="width:20%;">
                            </div>
                            <p class="foot-copy">&copy; Copyright <label id="copyrightyear"></label><a href="https://www.mobiotics.com" target="_blank">
                                <img class="v-middle foot-cmp-logo" style="width: 8em;" src="../assets/images/mobiotics-logo-horizontal.svg"></a></p>

                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-mid">
                                <ul>
                                    <li><a @click="openSocialNewTab('https://www.facebook.com/mobiotics')"><icon scale="1.2" class="white-text" name="facebook"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://plus.google.com/106588943035549674608/posts')"><icon scale="1.5" class="white-text" name="google-plus"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://twitter.com/mobiotics')"><icon scale="1.2" class="white-text" name="twitter"></icon></a></li>
                                </ul>
                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-right f-right">
                                <p class="foot-copy"><a href="#">Terms Of Use</a></p>
                                <p class="foot-copy"><a href="#">Privacy Policy</a></p>
                            </div>
                            <!-- <div class="vl-foot-right">
                            <ul>
                            <li><a href="#">Terms of use</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                        </ul>
                    </div> -->
                </grid-item>
            </grid>
        </container>
    </div>
    </footer>
    <!-- basic -->
  </div>



</div>



</template>

<script>
    const { Config } = require('../assets/js/config.js');
    import countTo from 'vue-count-to';
    import FixedHeader from 'vue-fixed-header';
    export default{
        data(){
            return{
                sidebarVisible: false,
                plans: [],
                planboxIndex: 2,
                plan: 'vl-plan-box',
                plan1: ['vl-plan-box','vl-plbox-1'],
                plan2: ['vl-plan-box','vl-plbox-2','box-active'],
                plan3: ['vl-plan-box','vl-plbox-3'],
                workrect:'works-rectangle',
                workrectcount:'wrk-rect-count',
                workrecttext:'wrk-rect-text',
                apibaseurl:'',
                vendorportalurl:'',
                test:[{0:1,1:1,2:1},{0:0,1:0,2:0}],
                moocArrayVal:[[1,1,1],[0,0,1],[1,1,1],[1,1,1],[0,1,1],[0,1,1],[0,1,1],[1,1,1],[1,1,1],[1,1,1],[1,1,1],[0,0,1]],
                liteArrayVal:[[1,1,1],[0,0,1],[1,1,1],[0,1,1],[0,1,1],[0,0,1],[1,1,1],[1,1,1],[1,1,1],[0,0,1]],
                moocArray:["iOS and Andriod Apps","Web App with SSL","Secure Sign Up and Authentication","Course Credit and Questionnaire","Course Level Management","Institute Management","Course Payments*","Google Analytics and Dashboard","Course and Progress Reporting","Business Hour Email Support","24*7 Reliable SASS","Free Bussiness Consulting"],
                liteArray:["iOS and Andriod Apps","Web App with SSL","Optional Signup and Authentication","Payments Support*","Ad Monetization Support*","DRM Support*","Google Analytics and Dashboard","Business Hour Email Support","24x7 Reliable SAAS ","Free Business Consulting"],
                listdataarr:[],
                listdataarrvals:[],
                bannerspace:false,
                landbanslide:'landing-banner-slide-syb',
                normaldevice: true,
                smalldevice: false,
                isFixed: false,
                showfixedheader: false,
                entviewdiv:false,
                mode:'MOOC',
                planhighlightbox:['vl-plan-highlight-box'],
                theme:'B'

            };
        },
        components: { countTo, 'fixed-header': FixedHeader },
        computed: {
            planData() {
                return this.plans;
            },
            // listDataArr() {
            //     return this.listdataarrvals;
            // },
        },
        created () {
           // console.log('on load event');
           this.screenResize();
        //    console.log(this.$route.query.mode);
           if(this.$route.query.mode){
                var mod = this.$route.query.mode;
               if(mod.toUpperCase() == 'LITE'){
                   this.mode = 'LITE';
                   this.planhighlightbox =['vl-plan-highlight-box','vl-plan-highlight-box-light'];
               }
           }
        //    VueScrollTo.scrollTo('#plans')
        },
        mounted() {
            var divpos = this.$route.params.divid;
            if (divpos){
                console.log('==============>'+divpos);
                this.$scrollTo('#'+divpos);
            }

            // Setting Config URLs
            var con = new Config()
            this.apibaseurl = con.getApiUrl();
            this.vendorportalurl = con.getPortalUrl();
            //Loading Plan info
            var hurl = this.apibaseurl+'/vendor/v1/plan?plantype=LITE';
            var payload = {};
            var protocol = window.location.protocol;
            this.$http({url: hurl, payload: payload, method: 'GET'}).then(function (response) {
                // console.log('Success!:', response.data);
                var data = response.data.data;
                var sorted = data.sort((a, b) => {
                      return a.yearlydiscountedprice.localeCompare(b.yearlydiscountedprice)
                    });
                this.plans = sorted;
            }, function (response) {
                console.log('Error!:', response.data);
            });
            this.listdataarr = this.moocArray;
            this.listdataarrvals = this.moocArrayVal;
            console.log(this.mode);
            if(this.mode == 'LITE'){
                document.getElementById("lite-plan-chk").checked = true;
                this.listdataarr = this.liteArray;
                this.listdataarrvals = this.liteArrayVal;
                this.entviewdiv=true;
            }


            //hero text toggle
            // console.log(document.getElementById("udemy").className.split(" ").indexOf("is-hidden"));
            // console.log(document.getElementById("neflix").className.split(" ").indexOf("is-hidden"));
            // setInterval(function(){
            //     var s1 = document.getElementById("udemy");
            //     var s2 = document.getElementById("neflix");
            //
            //     if(document.getElementById("udemy").className.split(" ").indexOf("is-hidden") >= 0) {
            //         console.log('inside');
            //           if(s1.className.split(" ").indexOf("is-hidden") >= 0) {
            //               s1.classList.remove("is-hidden");
            //           }
            //           s1.className += "is-visible";
            //
            //           if(s2.className.split(" ").indexOf("is-visible") >= 0) {
            //               s2.classList.remove("is-visible");
            //           }
            //           s2.className += "is-hidden";
            //       }
            //
            //       else{
            //           if(s2.className.split(" ").indexOf("is-hidden") >= 0) {
            //               s2.classList.remove("is-hidden");
            //           }
            //           s2.className += "is-visible";
            //
            //           if(s1.className.split(" ").indexOf("is-visible") >= 0) {
            //               s1.classList.remove("is-visible");
            //           }
            //           s1.className += "is-hidden";
            //       }
            //
            // },5000);
            let self = this;
            let cflag = 1;

            window.addEventListener('scroll', function(e) {
                if(cflag){
                    if(document.gambitGalleryIsInView(
                        document.querySelector('#ban-count-start')
                    )){
                        if(cflag){
                            self.$refs.example1.start();
                            self.$refs.example2.start();
                            self.$refs.example3.start();
                            cflag = 0;
                        }
                    }
                }


                let wheight = window.pageYOffset;
                let x = document.querySelector('#headerelement').clientHeight;
                // console.log(wheight+'  '+x);
                let tlimit = x+120;
                if(x < wheight){
                    self.showfixedheader = true;
                    // console.log('show f header');
                }else{
                    self.showfixedheader = false;
                    // console.log('show n header');
                }
            });

            document.gambitGalleryIsInView = function( el ) {
                if(el){
                    var viewport = {};
                    viewport.top = window.pageYOffset;
                    viewport.bottom = viewport.top + window.innerHeight;

                    var bounds = {};
                    bounds.top = el.getBoundingClientRect().top + window.pageYOffset
                    bounds.bottom = bounds.top + el.clientHeight;

                    return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
                    || (bounds.top <= viewport.bottom && bounds.top >= viewport.top );
                }
            };


            var thisYear  = new Date().getFullYear();
            document.getElementById('copyrightyear').innerHTML = thisYear;

        },
        watch: {
            '$mq.resize': 'screenResize',
        },
        methods: {
            toggleSidebar () {
                this.sidebarVisible = !this.sidebarVisible;
            },
            screenResize() {
                var scsize = screen.width;
                if((scsize >= 1500)){
                    this.workrect = ['works-rectangle'];
                    this.workrectcount = 'wrk-rect-count';
                    this.workrecttext = 'wrk-rect-text';
                    this.bannerspace = false;
                    this.landbanslide = 'landing-banner-slide-syb';
                    this.normaldevice= true;
                    this.smalldevice= false;

                }if((scsize <= 1499) && (scsize >= 1366)){
                    this.workrect = ['works-rectangle'];
                    this.workrectcount = 'wrk-rect-count';
                    this.workrecttext = 'wrk-rect-text';
                    this.bannerspace = false;
                    this.landbanslide = 'landing-banner-slide-syb';
                    this.normaldevice= true;
                    this.smalldevice= false;
                    // this.workrectcount = 'wrk-rect-count-40';
                    // this.workrecttext = 'wrk-rect-text-18';

                }else if ((scsize <= 1365) && (scsize >= 1200)) {
                    this.workrect = ['works-rectangle'];
                    this.workrectcount = 'wrk-rect-count-35';
                    this.workrecttext = 'wrk-rect-text-14';
                    this.bannerspace = false;
                    this.landbanslide = 'landing-banner-slide-syb';
                    this.normaldevice= true;
                    this.smalldevice= false;

                }else if ((scsize <= 1199) && (scsize >= 960)) {
                    this.workrect = ['works-rectangle-100'];
                    this.workrectcount = 'wrk-rect-count-35';
                    this.workrecttext = 'wrk-rect-text-14';
                    this.bannerspace = true;
                    this.landbanslide = 'landing-banner-slide-syb-small';
                    this.normaldevice= true;
                    this.smalldevice= false;

                }else if ((scsize <= 959) && (scsize >= 768)) {
                    this.workrect = ['works-rectangle-100'];
                    this.workrectcount = 'wrk-rect-count-35';
                    this.workrecttext = 'wrk-rect-text-14';
                    this.bannerspace = true;
                    this.landbanslide = 'landing-banner-slide-syb-small';
                    this.normaldevice= true;
                    this.smalldevice= false;
                }
                else if ((scsize <= 767) && (scsize >= 601)) {
                    this.workrect = ['works-rectangle-100'];
                    this.workrectcount = 'wrk-rect-count-35';
                    this.workrecttext = 'wrk-rect-text-14';
                    this.bannerspace = true;
                    this.landbanslide = 'landing-banner-slide-syb-small';
                    this.normaldevice= true;
                    this.smalldevice= false;

                }else if ((scsize <= 600) && (scsize >= 481)) {
                    this.workrect = ['works-rectangle-100'];
                    this.workrectcount = 'wrk-rect-count-35';
                    this.workrecttext = 'wrk-rect-text-14';
                    this.bannerspace = true;
                    this.landbanslide = 'landing-banner-slide-syb-small';
                    this.normaldevice= false;
                    this.smalldevice= true;

                }else if ((scsize <= 480) ) {
                    this.workrect = ['works-rectangle-100'];
                    this.workrectcount = 'wrk-rect-count-35';
                    this.workrecttext = 'wrk-rect-text-14';
                    this.bannerspace = true;
                    this.landbanslide = 'landing-banner-slide-syb-small';
                    this.normaldevice= false;
                    this.smalldevice= true;
                }
            },
            changelistdata: function(type){
                if(type == 'LITE'){
                    this.listdataarr = this.liteArray;
                    this.listdataarrvals = this.liteArrayVal;
                    this.entviewdiv=true;
                    this.mode='LITE';
                    this.planhighlightbox =['vl-plan-highlight-box','vl-plan-highlight-box-light'];
                    // console.log('LITE');
                }else{
                    this.listdataarr = this.moocArray;
                    this.listdataarrvals = this.moocArrayVal;
                    this.entviewdiv=false;
                    this.mode='MOOC';
                    this.planhighlightbox =['vl-plan-highlight-box'];
                    // console.log('MOOC');
                }
            },
          navigateToDashboard: function(index) {
              var priorplan ='';
              console.log(this.plans.length);
              console.log(index);
              if(this.plans.length > (index+1)){
                  priorplan = this.plans[index+1];
              }

              var inputElements = document.getElementsByName("type");
              var seltype = "MOOC";
              for(var i=0; inputElements[i]; ++i){
                  if(inputElements[i].checked){
                      seltype = inputElements[i].value;
                  }
              }
            this.$router.push({ name: 'Dashboard', params: { plandata: this.plans[index], priorplan: priorplan, seltype: seltype }});
            //this.$router.push('Dashboard', params: { plandata:  this.plans});
        },
        redirectToVlive(){
            this.$ga.event({
                  eventCategory: 'VLITE_REDIRECT',
                  eventAction: 'Redirect',
                  eventLabel: 'REDIRECT',
                  eventValue: 1
              });
              var retrievedObject = localStorage.getItem('themeObject');
              var resobj = JSON.parse(retrievedObject);
              var theme = new Date(resobj.number);
              var ver = 'A';
              if((theme%2) != 0){
                  ver = 'B';
              }
              // GTM Code starts
                   window.dataLayer = window.dataLayer || [];
                   window.dataLayer.push({
                       'event':'VLITE_REDIRECT',
                       'EventCategory': 'VLITE_HOME',
                       'EventAction': 'HOME',
                       'EventLabel': 'VLITE_HOME',
                       'EventValue': 1,
                       'Version': ver
                   });
              // End of GTM Code
        },
        openNewTab() {
            window.open(this.vendorportalurl, '_blank');
        },
        openSocialNewTab(surl){
            window.open(surl, '_blank');
        },
        navigateToDemoPage(){
            this.$router.push({ name: 'Reqdemo'});
        },
        scroll(element){
            document.getElementById(element).scrollIntoView();
            //var ele = document.getElementById(element);
            //window.scrollTo(ele.offsetLeft,ele.offsetTop);
        },
        appendActiveClass: function(id){
            // console.log("enter:"+id);
            var des = document.getElementById("vl-plan-box"+id);
            if(!document.getElementById("vl-plan-box"+id).className.split(" ").indexOf("box-active") >= 0) {
                des.className += " box-active";
            }

            if(id != this.planboxIndex){
                var sou = document.getElementById("vl-plan-box"+this.planboxIndex);
                if(document.getElementById("vl-plan-box"+this.planboxIndex).className.split(" ").indexOf("box-active") >= 0) {
                    sou.classList.remove("box-active");
                }
                //sou.className = sou.className.replace( /(?:^|\s)box-active(?!\S)/ , '' )
                this.planboxIndex = id;
            }
        }
        }
    }

</script>
<style>



</style>



// WEBPACK FOOTER //
// src/components/Home.vue